<template>
    <v-card-title class="dialog-header">
        <v-btn rounded="lg" v-show="mobile" :disabled="loading" variant="outlined" icon="mdi-close"
            class="dialog-header-close-btn-mobile" @click="$emit('close')"></v-btn>
        <div class="dialog-header-name">
            <h1>{{ agency.style.companyName }}</h1>
            <small class="last-seen">Last seen: {{ formatLastSeen(intercomLastSeen) }}</small>
        </div>
        <div class="dialog-header-link-buttons">
            <v-btn rounded="lg" elevation="4" :href="`https://dashboard.stripe.com/customers/${agency.stripeCustomerID}`"
                color="#635bff" target="_blank" icon="mdi-alpha-s-circle-outline"></v-btn>
            <v-btn rounded="lg" elevation="4" icon="mdi-information" color="#17100e" target="_blank"
                :href="`https://app.intercom.com/a/apps/lios09xl/${agency._id}`"></v-btn>
            <div style="position: relative;">
                <v-btn rounded="lg" elevation="4" icon="mdi-chart-line-stacked" color="#12324b" disabled></v-btn>
                <span style="position: absolute; top: -6px; right: -16px; background-color: red; color: white;
                        padding: 2px 5px; border-radius: 4px; font-size: 0.6em; height: 100%; max-height: 20px;
                        display: flex; justify-content: center; align-items: center;">
                    soon
                </span>
            </div>
        </div>
        <v-btn rounded="lg" v-show="!mobile" :disabled="loading" flat icon="mdi-close" class="dialog-header-close-btn"
            @click="$emit('close')"></v-btn>
    </v-card-title>
</template>

<script>
import { mapState } from 'vuex';
import { useDisplay } from 'vuetify'

export default {
    props: {
        agency: {
            type: Object,
            required: true
        },
        intercomLastSeen: {
            type: [Number, String, null],
            required: false,
            default: null
        },
    },
    setup() {
        const { mobile } = useDisplay();
        return { mobile };
    },
    computed: {
        ...mapState('agency', ['loading']),
    },
    methods: {
        formatLastSeen(ts) {
            if (!ts || Number.isNaN(Number(ts))) return "—";
            try {
                const d = new Date(Number(ts) * 1000);
                if (Number.isNaN(d.getTime())) return "—";
                return d.toLocaleString();
            } catch (e) {
                return "—";
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.dialog-header {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    max-width: 100%;
    padding: 16px 36px;

    @media screen and (max-width: 600px) {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 12px;
        padding: 12px 12px;
    }
}

.dialog-header-name h1 {
    font-size: 32px;
}
.last-seen {
    color: #6b7280;
    display: block;
    margin-top: 4px;
}

.dialog-header-link-buttons {
    display: flex;
    flex-direction: row;
    gap: 8px;

    @media screen and (max-width: 600px) {
        gap: 32px;
    }
}

.dialog-header-close-btn-mobile {
    margin-left: auto;
}

.dialog-header-close-btn {
    justify-self: end;
}
</style>